<div class="edit-container">
    <div class="d-flex justify-content-between align-items-center mb-4">
        <h1 class="edit-title m-0 p-0">Editare programări modul</h1>
        <button type="button" class="close" aria-label="Close" (click)="closeDialog()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <h3>Modul: {{moduleName}}</h3>

    <h3>Locații:</h3>
    <div class="row mb-3" *ngFor="let locatie of locatiiRows">
        <mat-checkbox color="primary" [(ngModel)]="locatie.checked">
            {{ locatie.name }}
        </mat-checkbox>
    </div>

    <h3>Program Locații:</h3>
    <mat-accordion>
        <ng-container *ngFor="let locatie of locatiiRows">
            <mat-expansion-panel class="mb-2" *ngIf="locatie.checked">
                <mat-expansion-panel-header class="group-header">
                    <mat-panel-title>
                        {{ locatie.name }}
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <mat-accordion *ngIf="tipuriProgramModul && tipuriProgramModul.length > 0; else noTipuriProgram">
                    <mat-expansion-panel *ngFor="let tipProgram of tipuriProgramModul">
                        <mat-expansion-panel-header class="group-header">
                            <mat-panel-title>
                                {{ tipProgram.name }}
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="program-content">
                            <div class="d-flex flex-wrap gap-2 mb-3">
                                <button *ngFor="let day of daysOfWeek" type="button" class="action-button"
                                    (click)="selectDay(day.id_day)" [class.active-day]="selectedDayID === day.id_day">
                                    <span>{{day.day}}</span>
                                </button>
                            </div>
                            <p>Intervale disponibile:</p>
                            <div class="d-flex justify-content-between flex-wrap gap-2">
                                <div class="row">
                                    <div class="col">
                                        <mat-form-field class="" appearance="fill">
                                            <mat-label>Ora</mat-label>
                                            <mat-select [(ngModel)]="selectedHour">
                                                <mat-option *ngFor="let hour of possibleHours" [value]="hour">
                                                    {{ hour }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col">
                                        <mat-form-field class="" appearance="fill">
                                            <mat-label>Minutul</mat-label>
                                            <mat-select [(ngModel)]="selectedMinute">
                                                <mat-option *ngFor="let minute of possibleMinutes" [value]="minute">
                                                    {{ minute }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <button type="button" class="my-2 action-button"
                                    (click)="addTime(locatie.id_locatie, tipProgram.id)">
                                    <span>Adaugă</span>
                                </button>
                            </div>
                            <div class="d-flex justify-content-between flex-wrap gap-2">
                                <mat-chip-listbox aria-label="Time selection">
                                    <ng-container *ngFor="let time of timeData; index as timeIndex">
                                        <mat-chip *ngIf="time.id_locatie === locatie.id_locatie && 
                                                time.id_program_type === tipProgram.id &&
                                                time.day === selectedDayID &&
                                                !time.deleted">
                                            {{ time.hour }}:{{ time.minute }}
                                            <button type="button" matChipRemove aria-label="Remove time"
                                                (click)="removeTime(timeIndex)">
                                                <mat-icon>cancel</mat-icon>
                                            </button>
                                        </mat-chip>
                                    </ng-container>
                                </mat-chip-listbox>
                            </div>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>

                <ng-template #noTipuriProgram>
                    <h4 class="mt-2 mb-0">Generați minim un tip de program
                        activ pentru acest modul!</h4>
                </ng-template>
            </mat-expansion-panel>
        </ng-container>
    </mat-accordion>

    <div class="row">
        <div class="col d-flex justify-content-between">
            <button class="buttons" type="button" mat-flat-button (click)="closeDialog()">
                {{ helper.dialogConfig.buttonLabels.close }}
            </button>
            <button class="buttons" type="button" mat-flat-button color="primary" [disabled]="isLoading"
                (click)="updateTimesModul()">
                {{ helper.dialogConfig.buttonLabels.save }}
            </button>
        </div>
    </div>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>